<template>
    <div>

        <el-dialog :close-on-click-modal="false" title="BUSCAR CBO (OCUPAÇÃO)" width="70%" :visible.sync="dialogSearchCbo" v-on:close="closeDialog">

            <el-row :gutter="10" class="u-mb-10 u-mt-10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-input key="cbo-termo" placeholder="Pesquisar por nome ou código do CBO" v-model="filtros.termo" maxlength="191" @keyup.native.enter="changeFiltros">
                        <el-button slot="append" icon="el-icon-search" @click="changeFiltros">PESQUISAR</el-button>
                    </el-input>
                </el-col>
            </el-row>

            <div class="container-table" style="height: 295px;">
                <table class="table table-striped table--hover">
                    <thead>
                        <tr>
                            <th style="width: 130px;">Código</th>
                            <th>Ocupação (CBO)</th>
                        </tr>
                    </thead>
                    <tbody v-if="!loadingCbo">
                        <tr v-for="cbo in cbos" :key="cbo.id" @click="selectCbo(cbo)" class="u-pointer" style="user-select: none;">
                            <td>{{ cbo.codigo }}</td>
                            <td>{{ cbo.nome }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr v-if="!loadingCbo && cbos.length == 0" style="border-top: 1px solid #ddd;">
                            <td colspan="100%" class="u-text-center">
                                <span>nenhum registro</span>
                            </td>
                        </tr>
                    </tfoot>
                </table>
                <div v-if="loadingCbo" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <div class="footer-search">
                    <div>
                        <el-pagination :current-page="paginate.page" v-if="paginate.qtdCbos > 9" :page-size="9" :total="paginate.qtdCbos" @current-change="getPagePagination" background layout="prev, pager, next" small></el-pagination>
                    </div>
                    <div>
                        <el-button type="danger" @click="closeDialog">CANCELAR</el-button>
                        <el-button type="primary" @click="getCbo">PESQUISAR</el-button>
                    </div>
                </div>
            </span>
        </el-dialog>
    </div>
</template>
<script>

export default {
    props: {
        open: {
            required: false,
            type: [Boolean],
            default: false
        },
    },
    data: () => ({
        paginate: {
            page: 1,
            qtdCbos: null,
        },
        filtros: {
            termo: ''
        },
        cbos: [],
        dialogSearchCbo: false,
        loadingCbo: false,
    }),
    methods: {
        selectCbo(cbo){

            this.$emit('emitCbo', cbo);
        },
        changeFiltros(){

            this.paginate.page = 1;
            this.getCbo();
        },
        closeDialog(){

            this.$emit('close');
            this.filtros = { termo: '' };
            this.cbos = [];
        },
        getCbo(){

            this.loadingCbo = true;

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/cbo/getByFiltrosPaginate?page=${this.paginate.page}`, this.filtros, this.$store.getters.getHeaderAuth).then(response => {

                this.cbos = response.data.data;
                this.paginate.qtdCbos = response.data.total;
                this.loadingCbo = false;

            }).catch((error) => { this.loadingCbo = false; this.$store.commit('throwException', error); });
        },
        getPagePagination(page){
            this.paginate.page = page;
            this.getCbo();
        },
    },
    watch: {
        open: {
            immediate: true,
            handler (value) {

                this.dialogSearchCbo = value;
                if (value) { this.getCbo(); }
            }
        },
    }
}
</script>
